/*
import {
  hf,
  hfDTM,
  ht,
  cmPDF,
} from 'lib';
*/
import * as cmPDF from "./_cmPDF";
import * as ht from './_ht';
import * as hf from './_hf';
import * as hfDTM from './_hfDTM';

export const eptPdfAsync1 = async (pz: { // 使用状況
  date: ht.s
  i11rs: ht.ls,
}) => {

  let _fileName = `使用状況_${hfDTM.f(pz.date, 'YYYYMMDD')}.pdf`;
  let _lines = [] as ht.ls;

  let _cmnCntTbl = 78; // table with
  let _cmnCntLbl = 10; // label Width
  const _rowCntHdr = 2; // header height
  const _rowCntLine = 6; // line height

/*
  let _row = 0;
  _lines.push({ type: 'text', pfx: `使用状況一覧`,  cmn: 1, row: _row, cmnCnt: 27, rowCnt: 2, ta: 'ctr', frm: false, ts: 1.2, bold: true });
  _lines.push({ type: 'text', pfx: hfDTM.f(pz.date, '年月日', false),  cmn: 28, row: _row, cmnCnt: 27, rowCnt: 2, ta: 'ctr', frm: false, ts: 1, bold: true });
  _row +=3;

  pz.i11rs.map((_i11rz: ht.dz) => {
    const _i111s = _i11rz?.cldz?.i111s;
    const _i10rs = _i11rz?.cldz?.i10rs;
    if (hf.f(_i111s) && hf.f(_i10rs)) {
      let _cmn = _cmnCntLbl + 1;
      const _cmnCnt = (_cmnCntTbl - _cmnCntLbl) /  _i111s.length;
      _i111s.map((_i111z: ht.dz) => {
        _lines.push({ type: 'text', pfx: _i111z._pfx,  cmn: _cmn, row: _row, cmnCnt: _cmnCnt, rowCnt: _rowCntHdr, ta: 'ctr', frm: true, ts: 1.0, bold: false });
        _cmn += _cmnCnt;
      })
      _row += _rowCntHdr;

      _i10rs.map((_i10rz: ht.dz) => {
        _lines.push({ type: 'text', pfx: _i10rz._pfx,  cmn: 1, row: _row, cmnCnt: 10, rowCnt: _rowCntLine, ta: 'ctr', frm: true, ts: 1.0, bold: false });

        const _i111s = _i10rz?.cldz?.i111s;
        let _cmn = _cmnCntLbl + 1;
        _i111s.map((_i111z: ht.dz) => {
          const _i1z1z = hf.get1(_i111z?.cldz?.i1z1s, {});
          const _i1zrz = hf.get1(_i1z1z?.cldz?.i1zrs, {});
          const _i18rz = hf.get1(_i1zrz?.cldz?.i18rs, {});
          const _pfx = (_i18rz?.i18rab100s ?? '') + ' ' + (_i18rz?._pfx ?? '');
          _lines.push({ type: 'text', pfx: _pfx,  cmn: _cmn, row: _row, cmnCnt: _cmnCnt, rowCnt: _rowCntLine, ta: 'ctr', frm: true, bMln: true, ts: 1.0, bold: false });
          _cmn += _cmnCnt;
        });

        _row += _rowCntLine;
      });
      _row += 1;
    };
  })
*/

  let _row = 0;
  pz.i11rs.map((_i11rz: ht.dz, _idx1: ht.n) => {

    //hf.l(`icvI11___Ez 62: ${_idx1}, ${_idx1 % 5}`)
    if ( _idx1 > 0 ) {
      _row = 0;
      _lines.push({ type: 'pstCvsToPdf' });
      _lines.push({ type: 'addNewPageToPdf' });
      _lines.push({ type: 'clrCvs' });
    }
    _lines.push({ type: 'text', pfx: `使用状況一覧`,  cmn: 1, row: _row, cmnCnt: 27, rowCnt: 2, ta: 'ctr', frm: false, ts: 1.2, bold: true });
    _lines.push({ type: 'text', pfx: hfDTM.f(pz.date, '年月日', false),  cmn: 28, row: _row, cmnCnt: 27, rowCnt: 2, ta: 'ctr', frm: false, ts: 1, bold: true });
    _row +=3;

    const _i111s = _i11rz?.cldz?.i111s;
    const _i10rs = _i11rz?.cldz?.i10rs;
    if (hf.f(_i111s) && hf.f(_i10rs)) {
      let _cmn = _cmnCntLbl + 1;
      const _cmnCnt = (_cmnCntTbl - _cmnCntLbl) /  _i111s.length;
      _i111s.map((_i111z: ht.dz) => {
        _lines.push({ type: 'text', pfx: _i111z._pfx,  cmn: _cmn, row: _row, cmnCnt: _cmnCnt, rowCnt: _rowCntHdr, ta: 'ctr', frm: true, ts: 1.0, bold: false });
        _cmn += _cmnCnt;
      })
      _row += _rowCntHdr;

      _i10rs.map((_i10rz: ht.dz, _idx2: ht.n) => {

        if ( _idx2 > 0 && _idx2 % 5 == 0 ) {
          _row = 0;
          _lines.push({ type: 'pstCvsToPdf' });
          _lines.push({ type: 'addNewPageToPdf' });
          _lines.push({ type: 'clrCvs' });
          _lines.push({ type: 'text', pfx: `使用状況一覧`,  cmn: 1, row: _row, cmnCnt: 27, rowCnt: 2, ta: 'ctr', frm: false, ts: 1.2, bold: true });
          _lines.push({ type: 'text', pfx: hfDTM.f(pz.date, '年月日', false),  cmn: 28, row: _row, cmnCnt: 27, rowCnt: 2, ta: 'ctr', frm: false, ts: 1, bold: true });
          _row +=3;
        }

        //hf.l(`icvI11___Ez 97: ${_row}, ${_rowCntLine}`);
        _lines.push({ type: 'text', pfx: _i10rz._pfx,  cmn: 1, row: _row, cmnCnt: 10, rowCnt: _rowCntLine, ta: 'ctr', frm: true, mlt: true, ts: 1.0, bold: false }); // 部屋名

        const _i111s = _i10rz?.cldz?.i111s;
        let _cmn = _cmnCntLbl + 1;
        _i111s.map((_i111z: ht.dz) => {
          const _i1z1z = hf.get1(_i111z?.cldz?.i1z1s, {});
          const _i1zrz = hf.get1(_i1z1z?.cldz?.i1zrs, {});
          const _i18rz = hf.get1(_i1zrz?.cldz?.i18rs, {});
          const _pfx = (_i18rz?.i18rab100s ?? '') + ' ' + (_i18rz?._pfx ?? '');
          _lines.push({ type: 'text', pfx: _pfx,  cmn: _cmn, row: _row, cmnCnt: _cmnCnt, rowCnt: _rowCntLine, ta: 'ctr', frm: true, mlt: true, ts: 1.0, bold: false }); // 部屋・時間帯ごとの予約情報
          _cmn += _cmnCnt;
        });

        _row += _rowCntLine;
      });
      _row += 1;
    };
  })

  _lines.push({ type: 'pstCvsToPdf' });
  _lines.push({ type: 'savePdf' });

  await cmPDF.dwlFileAsync({
    fileName: _fileName,
    lines: _lines,
    itlz: {
//      orientation: 'portrait',
    },
  });

};

export const eptPdfAsync2 = (pz: { // 部屋別掲示PDF
  date: ht.s,
  i11rs: ht.ls,
}) => {

  let _fileName = `部屋別掲示_${hfDTM.f(pz.date, 'YYYYMMDD')}.pdf`;
  let _lines = [] as ht.ls;

  let _cnt = 0;  
  let _row = 0;
  pz.i11rs.map( ( _i11rz: ht.dz ) => {
    const _i10rs  = _i11rz.cldz.i10rs;
    _i10rs.map( (_i10rz: ht.dz) => {

      const _i111s  = _i10rz.cldz.i111s;

      _cnt += 1;
      if (_cnt > 1) {
        _lines.push({ type: 'clrCvs' });
        _lines.push({ type: 'addNewPageToPdf' });
      };

      _row = 1;
      _lines.push({ type: 'text', pfx: _i10rz._pfx,  cmn: 1, row: _row, cmnCnt: 36, rowCnt: 3, ta: 'ctr', frm: false, ts: 2.8, tb: true });
      _lines.push({ type: 'text', pfx: hfDTM.f(pz.date, '年月日', false),  cmn: 37, row: _row, cmnCnt: 41.5, rowCnt: 3, ta: 'ctr', frm: false, ts: 1.8, tb: true });

      _row = 5;
      let _rowCntBdy = (34 - 5) / _i111s.length;
      _i111s.map((_i111z: ht.dz) => {
        const _i1z1z = hf.get1(_i111z?.cldz?.i1z1s, {});
        const _i1zrz = hf.get1(_i1z1z?.cldz?.i1zrs, {});
        const _i18rz = hf.get1(_i1zrz?.cldz?.i18rs, {});
        const _pfx = (_i18rz?.i18rab100s ?? '') + ' ' + (_i18rz?._pfx ?? '');
        _lines.push({ type: 'text', pfx: _i111z._pfx,  cmn: 1, row: _row, cmnCnt: 20, rowCnt: _rowCntBdy, ta: 'ctr', frm: true, ts: 1.8, tb: true });
        _lines.push({ type: 'text', pfx: _pfx,  cmn: 21, row: _row, cmnCnt: 57.5, rowCnt: _rowCntBdy, ta: 'ctr', frm: true, ts: 1.8, tb: true });
        _row += _rowCntBdy;
      });

      _lines.push({ type: 'pstCvsToPdf' });

    });
  });

  _lines.push({ type: 'savePdf' });

  cmPDF.dwlFileAsync({
    fileName: _fileName,
    lines: _lines,
    itlz: {
      orientation: 'landscape',
    },
  })
};

